import { render, staticRenderFns } from "./TemplateCustomisationSectionFields.vue?vue&type=template&id=641201ea&scoped=true&"
import script from "./TemplateCustomisationSectionFields.vue?vue&type=script&lang=ts&"
export * from "./TemplateCustomisationSectionFields.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCustomisationSectionFields.vue?vue&type=style&index=0&id=641201ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641201ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCombobox,VDataTable,VFileInput,VRow,VTextField,VTextarea})
